import api from '../../plugins/api';

const getDeals = (params) => {
  return api.get('/api/crm/deals/getDeals', params);
};

export default getDeals;
